type BackCallback = () => void;
type UnmountCallback = () => void;

const modalStack: Array<{ id: number; handleBack: BackCallback; handleUnmount?: UnmountCallback }> = []

let idCounter = 0

export function pushModal(handleBack: BackCallback, handleUnmount?: UnmountCallback) {
  const id = ++idCounter
  modalStack.push({ id, handleBack, handleUnmount })
  return id
}

export function popModal(id: number) {
  const index = modalStack.findIndex(modal => modal.id === id)
  if (index !== -1) {
    const [modal] = modalStack.splice(index, 1)
    if (modal.handleUnmount) modal.handleUnmount()
  }
}

export function getTopModal() {
  return modalStack.length > 0 ? modalStack[modalStack.length - 1] : null
}
